import { isNil } from 'lodash';

const generatePathName = (array: (string | number | undefined)[], separator = '.') => array.filter(part => !isNil(part)).join(separator);

export default generatePathName;
